// apps/admin/src/app/RouteFallback.tsx
//
// The <Suspense> fallback for a lazily-loaded route (see routes.tsx). Every
// screen in this app already renders its own "Loading…" this same way while
// its data fetches (ContentModel, EntryEditor, ContentBrowser's table) — a
// route waiting on its own *code* to arrive should look identical, not drop
// back to a bare spinner that reads as a different, unstyled product.
export function RouteFallback() {
  return (
    <div className="screen" style={{ padding: 'var(--space-8)' }}>
      <p className="text-muted" style={{ margin: 0, fontSize: 13 }}>
        Loading…
      </p>
    </div>
  )
}
